import useAutoHoverAnimation from '../../hooks/useAutoHoverAnimation';

export default function HeroBanner() {
    const titleRef = useAutoHoverAnimation(100, 100, 600);

    return (
        <>
            <div id="hero">
                <div id="hero-video-background">
                    <img src="/images/faq-page-banner.jpg" alt="About Us Hero" />
                </div>
                <div id="hero-styles">
                    <div id="hero-caption" className="height-title content-full-width text-align-center parallax-scroll-caption">
                        <div className="inner">
                            <h1 ref={titleRef} className="hero-title caption-timeline primary-font-title">
                                <div>
                                    <span>F</span>
                                    <span>R</span>
                                    <span>E</span>
                                    <span>Q</span>
                                    <span>U</span>
                                    <span>E</span>
                                    <span>N</span>
                                    <span>T</span>
                                    <span>L</span>
                                    <span>Y</span>
                                    <span>&nbsp;</span>
                                    <span>A</span>
                                    <span>S</span>
                                    <span>K</span>
                                    <span>E</span>
                                    <span>D</span>
                                    <span>&nbsp;</span>
                                    <span>Q</span>
                                    <span>U</span>
                                    <span>E</span>
                                    <span>S</span>
                                    <span>T</span>
                                    <span>I</span>
                                    <span>O</span>
                                    <span>N</span>
                                    <span>S</span>
                                </div>
                            </h1>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
} 